import classNames from 'classnames';
import React from 'react';

export const Image = ({ src, alt, className }) => {
  return (
    <div className={classNames('cell', 'small-12', 'large-5', 'small-order-2', className)}>
      <img src={src} alt={alt} />
    </div>
  );
};

export const TextContent = ({ className, children }) => {
  return (
    <div className={classNames('cell', 'small-12', 'large-7', 'small-order-1', className)}>
      {children}
    </div>
  );
};

export const ImageTextRow = ({ className, children }) => {
  return (
    <div
      className={classNames(
        'grid-x',
        'grid-margin-x',
        'align-middle',
        className
      )}
    >
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/elements/ImageTextRow/index.js